export const initialState = {
  diseases: []
};
